<template>
    <div class="order-setting">
        <form @submit.prevent="onSave">
            <div class="form-row">
                <label>{{ lang.bsso_tax_label }}</label>
                <label :for="taxId" :class="['checkSwitch', 'badge badge-xs', tax_enabled ? 'badge-success' : 'badge-secondary']">
                    <div class="iCheckswitch">
                        <input type="checkbox" :id="taxId" v-model="tax_enabled" />
                        <label class="iCheckswitch-label" :for="taxId">
                            <span class="iCheckswitch-inner"></span>
                        </label>
                    </div>
                    <span class="form-check-label-text" v-if="tax_enabled">{{ lang.bs_on }}</span>
                    <span class="form-check-label-text" v-else>{{ lang.bs_off }}</span>
                </label>
                <input type="number" v-model.number="tax_percent" min="0" max="100" step="0.01" />
                <span class="form-suffix">%</span>
            </div>

            <div class="form-row">
                <label>{{ lang.bsso_delivery_fee_label }}</label>
                <label :for="deliveryId" :class="['checkSwitch', 'badge badge-xs', delivery_enabled ? 'badge-success' : 'badge-secondary']">
                    <div class="iCheckswitch">
                        <input type="checkbox" :id="deliveryId" v-model="delivery_enabled" />
                        <label class="iCheckswitch-label" :for="deliveryId">
                            <span class="iCheckswitch-inner"></span>
                        </label>
                    </div>
                    <span class="form-check-label-text" v-if="delivery_enabled">{{ lang.bs_on }}</span>
                    <span class="form-check-label-text" v-else>{{ lang.bs_off }}</span>
                </label>
                <input type="number" v-model.number="delivery_fee" min="0" step="0.01" />
                <span class="form-suffix">{{ currency }}</span>
            </div>

            <div class="form-row">
                <label>{{ lang.bsso_privacy_link }}</label>
                <input type="text" v-model.trim="privacy_link" placeholder="https://..." style="text-align: left;"/>
            </div>

            <div class="form-row">
                <label>{{ lang.bsso_terms_link }}</label>
                <input type="text" v-model.trim="terms_link" placeholder="https://..." style="text-align: left;"/>
            </div>

            <div class="form-row">
                <label>{{ lang.bsso_return_link }}</label>
                <input type="text" v-model.trim="return_link" placeholder="https://..." style="text-align: left;"/>
            </div>

            <div class="form-actions">
                <button type="submit" class="btn btn-primary btn-lg">{{ lang.bs_save }}</button>
                <button type="button" class="btn btn-lg" @click="onCancel">{{ lang.bs_cancel }}</button>
            </div>
        </form>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
    name: 'OrderSetting',
    props: {
        value: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            lang: {
                bsso_tax_label: '',
                bs_on: '',
                bs_off: '',
                bsso_delivery_fee_label: '',
                bsso_privacy_link: '',
                bsso_terms_link: '',
                bsso_return_link: '',
                bs_save: '',
                bs_cancel: '',
            },
            tax_percent: this.value.tax_percent != null ? this.value.tax_percent : 0,
            tax_enabled: this.value.tax_enabled != null ? !!this.value.tax_enabled : false,
            delivery_fee: this.value.delivery_fee != null ? this.value.delivery_fee : 0,
            delivery_enabled: this.value.delivery_enabled != null ? !!this.value.delivery_enabled : false,
            booking_cal_enabled: this.value.booking_cal_enabled != null ? !!this.value.booking_cal_enabled : false,
            privacy_link: this.value.privacy_link || '',
            terms_link: this.value.terms_link || '',
            return_link: this.value.return_link || '',
            taxId: `tax_${Math.random().toString(36).slice(2, 6)}`,
            deliveryId: `delivery_${Math.random().toString(36).slice(2, 6)}`,
            bookingCalId: `booking_cal_${Math.random().toString(36).slice(2, 6)}`,
        };
    },
    created() {
        this.lang = this.$store.getters['ModApps/Marketea/lang'];
    },
    computed: {
        ...mapGetters("ModApps/Marketea/", {
            currency: "get_bStore_currency",
            langGetter: "lang",
        }),
    },
    watch: {
        langGetter() {
            this.lang = this.$store.getters['ModApps/Marketea/lang'];
        },
    },
    methods: {
        onSave() {
            const payload = {
                tax_percent: Number(this.tax_percent) || 0,
                tax_enabled: this.castBoolean(this.tax_enabled) ? 1 : 0,
                delivery_fee: Number(this.delivery_fee) || 0,
                delivery_enabled: this.castBoolean(this.delivery_enabled) ? 1 : 0,
                booking_cal_enabled: this.castBoolean(this.booking_cal_enabled) ? 1 : 0,
                privacy_link: this.privacy_link,
                terms_link: this.terms_link,
                return_link: this.return_link,
            };
            this.$emit('save', payload);
        },
        onCancel() {
            this.$emit('cancel');
        },
        castBoolean(val) {
            if (typeof val === 'string') {
                return val === 'true' || val === '1';
            }
            if (typeof val === 'number') {
                return val !== 0;
            }
            return !!val;
        }
    }
}
</script>

<style lang="scss" scoped>
.order-setting {
    max-width: 600px;
}

.form-row {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 8px 0;

    label {
        width: 180px;
    }

    input[type="text"],
    input[type="number"] {
        flex: 1;
        padding: 6px;
        text-align: right;
    }
}

.radio-inline {
    margin-right: 8px;
}

.form-actions {
    margin-top: 12px;
    display: flex;
    gap: 8px;
}

</style>
